import React from 'react';
import './Footer.scss';

class Footer extends React.Component {
    // constructor (props) {
    //   super(props);
    //   this.state = {
  
    //   }
    // }
    render() {
        return (
            <footer className="Footer">
                <p>Footer в процессе</p>
            </footer>
        )
    }   
}

export default Footer;